import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';

import { getEmailTemplatesFetchingActions } from '../../../redux/actions/emailTemplatesActions';
import Loading from '../../../shared/components/Loading';
import { columns } from './emailTemplateColumns';
import DataReactTable from '../../Tables/DataTable/components/DataReactTable';
import { parse, stringify } from 'query-string';
import { useLocation } from 'react-router-dom';

const EmailTemplates = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { emailTemplates, loading, errors, totalRecords } = useSelector((state) => state.emailTemplates);
  const dispatch = useDispatch();
  const location = useLocation();
  const parsedQuery = parse(location.search);
  const [currentPage, setCurrentPage] = useState(+parsedQuery?.start || 1);
  const [pageLimit, setPageLimit] = useState(+parsedQuery?.limit || 10);
  const [order, setOrder] = useState({name: 'id', desc: 'desc'});


  useEffect(() => {
    const updatedQuery = {
      start: (currentPage - 1) * pageLimit,
      limit: pageLimit
    };

    navigate(`${location.pathname}?${stringify({start: currentPage, limit: pageLimit}, {arrayFormat: 'comma'})}`);
    dispatch(getEmailTemplatesFetchingActions(updatedQuery, order));
  }, [currentPage, pageLimit, dispatch, location.pathname, navigate, order]);

  const renderContent = () => {
    if (loading) {
      return <Loading />;
    }

    if (!emailTemplates || emailTemplates.length === 0) {
      return <p>{t('empty_states.default')}</p>
    }

    const handleChangePage = (newPage) => {
      setCurrentPage(newPage);
    };

    const handleChangePageSize = (newSize) => {
      setCurrentPage(1);
      setPageLimit(newSize);
    };

    return (
      <Card>
        <CardBody>
          <DataReactTable
            tableName={"Email Templates"}
            pagination={{
              onChangePageSize: handleChangePageSize,
              onChangePage: handleChangePage,
              currentPage,
              totalRecords,
              pageLimit
            }}
            sortTable={true}
            onSortChange={(sortBy) => {
              const { id, desc } = sortBy[0] || {};
              const newOrder = { name: id, desc: desc ? 'desc' : 'asc' };
              if (id && (order.name !== newOrder.name || order.desc !== newOrder.desc)) {
                setOrder(newOrder);
              }
            }}
            search={false}
            emptyStateMessage={t('empty_states.invoices')}
            reactTableData={{tableHeaderData: columns, tableRowsData: emailTemplates?.map((c) => {
                return {...c,
                  id: `${c.id}`,
                  actions: (
                    <>
                      <Button className="m-0" color="primary" size="sm" outline onClick={() => {
                        navigate(`/settings/email-templates/${c.id}`);
                      }}>
                        {t('email_template.btn_edit')}
                      </Button>
                    </>
                  )
                }
              })}}
          />
          {/*<Table responsive>*/}
          {/*  <thead>*/}
          {/*    <tr>*/}
          {/*      <th>ID</th>*/}
          {/*      <th>{t('email_template.table_subject')}</th>*/}
          {/*      <th>{t('email_template.table_actions')}</th>*/}
          {/*    </tr>*/}
          {/*  </thead>*/}
          {/*  <tbody>*/}
          {/*    {emailTemplates.map((item) => {*/}
          {/*      return (*/}
          {/*        <tr key={item.id}>*/}
          {/*          <td>{item.id}</td>*/}
          {/*          <td>{item.subject}</td>*/}
          {/*          <td>*/}
          {/*            <Button className="m-0" color="primary" size="sm" outline onClick={() => {*/}
          {/*              navigate(`/settings/email-templates/${item.id}`);*/}
          {/*            }}>*/}
          {/*              {t('email_template.btn_edit')}*/}
          {/*            </Button>*/}
          {/*          </td>*/}
          {/*        </tr>*/}
          {/*      );*/}
          {/*    })}*/}
          {/*  </tbody>*/}
          {/*</Table>*/}
        </CardBody>
      </Card>
    );
  }

  return (
    <Container className="email-templates">
      <Row>
        <Col>
          {renderContent()}
          {
            errors ? (<div>{errors}</div>) : null
          }
        </Col>
      </Row>
    </Container>
  );
};

export default EmailTemplates;